"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useOfflineIndicator2 = _interopRequireDefault(require("./use-offline-indicator"));
require("./offline-indicator.css");
var _excluded = ["label"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Provides an Indicator for offline network status
 */
var OfflineIndicator = function OfflineIndicator(_ref) {
  var label = _ref.label,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useOfflineIndicator = (0, _useOfflineIndicator2["default"])(),
    isOffline = _useOfflineIndicator.isOffline;
  return isOffline ? /*#__PURE__*/_react["default"].createElement("div", otherProps, /*#__PURE__*/_react["default"].createElement("div", {
    className: "sb-offline-indicator-base"
  }, label || 'Offline')) : null;
};
OfflineIndicator.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * label that displays the offline indicator message
   */
  label: _propTypes["default"].string.isRequired
} : {};
var _default = exports["default"] = OfflineIndicator;